import React, {useRef, useState} from 'react';
import {Icon, Popup} from 'semantic-ui-react';

import {IconQuestionCircleOutline} from '@appComponents/IconCollection';
import {ARGOS_DASHBOARD_URL} from '@constants/variables';

const ArgosJobLiveControlLegend = () => {
    const [open, setOpen] = useState(false);
    const [showLegend, setShowLegend] = useState(false);
    const showLegendRef = useRef(false);
    showLegendRef.current = showLegend;

    const content = (
        <div className='liveControlLegend'>
            <div className='legendBlock'>
                The Argos job Live Control page shows all of the Argos jobs verifying one of the following
                conditions:
                <ul>
                    <li>Argos job is being processed.</li>
                    <li>
                        Argos job belongs to an event with a start time within the selected time-frame.
                    </li>
                </ul>
            </div>
            <div className='legendBlock'>
                <div className='legendTitle'>Legend</div>
            </div>
            <div className='legendBlock'>
                <div className='legendColor --green'/>
                Argos jobs which are running and which are processing the stream.
            </div>
            <div className='legendBlock'>
                <div className='legendColor --yellow'/>
                Other Argos jobs which have started and not terminated.
            </div>
        </div>
    );

    const openArgosDashboard = () => {
        window.open(ARGOS_DASHBOARD_URL, '_blank', 'noopener');
    };

    const close = () => {
        setOpen(false);
        setShowLegend(false);
    };

    return (
        <div className='liveControl__indexLegend content__buttons'>
            <Popup
                content='Open the Argos dashboard'
                trigger={
                    <Icon
                        name='dashboard'
                        link
                        onClick={openArgosDashboard}
                        size='large'
                    />
                }
            />
            <Popup
                content={showLegend ? content : 'Help / Legend'}
                on={showLegend ? 'click' : []}
                open={open}
                onClose={close}
                position='bottom left'
                trigger={
                    <IconQuestionCircleOutline
                        size='large'
                        onMouseEnter={() => {
                            if (!showLegendRef.current) {
                                setOpen(true);
                            }
                        }}
                        onMouseLeave={() => {
                            if (!showLegendRef.current) {
                                setOpen(false);
                            }
                        }}
                        onClick={() => {
                            setShowLegend((wasOpen) => {
                                const next = !wasOpen;
                                setOpen(next);

                                return next;
                            });
                        }}
                    />
                }
            />
        </div>
    );
};

export default ArgosJobLiveControlLegend;
